// Migrated from Dayforce: UI\Framework\Scripts\Framework\Modules\FileSizeUtil.ts

interface ISizes {
    kb: number;
    mb: number;
    gb: number;
    bytes: number;
    value: string;
}
/**
 * Converts number of bytes into object
 * that holds number of MB, KB, etc. information
 * for easier display
 * @param bytes the number of bytes
 * @returns an object that holds number of Bytes, KB, MB, KB, and value string with one fraction digit and unit name.
 */
function convertBytes(bytes: number): ISizes {
    var kb = Math.round((bytes / 1024) * 100000) / 100000;
    var mb = Math.round((bytes / 1048576) * 100000) / 100000;
    var gb = Math.round((bytes / 1073741824) * 100000) / 100000;
    var value = bytes.toFixed(0) + " Bytes";

    if (kb > 1) value = kb.toFixed(1) + " KB";
    if (mb > 1) value = mb.toFixed(1) + " MB";
    if (gb > 1) value = gb.toFixed(1) + " GB";

    return { kb: kb, mb: mb, gb: gb, bytes: bytes, value: value };
}

/**
 * FileSizeUtil is a simple module with basic math for parsing
 * file size in bytes into the object
 **/
export const FileSizeUtil = {
    convertBytes,
};
